import PropTypes from "prop-types";
import { useFormatDate } from "hooks/useFormatDate";

export function DateOnlyCell({ value, fallback = "" }) {
  const { formatDateOnly } = useFormatDate();
  if (!value) return fallback;
  return formatDateOnly(value);
}

DateOnlyCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  fallback: PropTypes.string,
};

export function DateTimeCell({ value, fallback = "" }) {
  const { formatDateTime } = useFormatDate();
  if (!value) return fallback;
  return formatDateTime(value);
}

DateTimeCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  fallback: PropTypes.string,
};
